import { useSelector, useDispatch } from 'react-redux';
import {useEffect, useState} from 'react';
import { CartoLayer, colorBins } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';
import { useAppState } from 'components/contexts/State';

export const HARD_BRAKING_SOURCE_LAYER_ID = 'hardBrakingLayer';

const layerConfig = {
  title: 'VRU Segment Hard Braking Map',
};

function HardBrakingLayer() {
  const dispatch = useDispatch();
  const { hardBrakingLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) => selectSourceById(state, hardBrakingLayer?.source));
  const cartoLayerProps = useCartoLayerProps({ source });
  const viewState = useSelector((state) => state.carto.viewState);
  const pointLineWidth = viewState.zoom >= 7 ? 4 : 2;
  let [domainArray] = useState([0.051, 0.068, 0.094, 0.156]);




  if (hardBrakingLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: HARD_BRAKING_SOURCE_LAYER_ID,
      geoColumn: 'geom',
      stroked: false,
      filled: true,
      lineWidthMinPixels: pointLineWidth,
      lineWidthMaxPixels: 10,
      pickable: true,
      lineWidthScale: 1,
      visible: hardBrakingLayer.visible,
      opacity: hardBrakingLayer.opacity,

      getLineColor: colorBins({
        attr: 'Normalized_HBE_Ratio',
        domain: domainArray,
        colors: [
          [120, 38, 56, 64],
          [120, 38, 56, 128],
          [120, 38, 56, 179],
          [120, 38, 56, 217],
          [120, 38, 56, 255],
        ],
      }),
      coverage: 0.95,
      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: HARD_BRAKING_SOURCE_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              //includeColumns: ['h3'],
            }),
          };
        }
      },
    });
  }
}

export default HardBrakingLayer;
